import { Textarea, TextareaProps } from '@chakra-ui/react';

const defaultStyles: TextareaProps = {
    backgroundColor: 'white',
    resize: 'none',
};

export function DrawerTextarea(props: TextareaProps) {
    return <Textarea {...defaultStyles} {...props} />;
}
